module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Ha.f3fb9b5a.png";